import React, { Component } from "react";

const DrinksIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 23"
      fill="none"
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.6065 8.48406C17.05 7.83484 16.7201 7.00694 16.6774 6.15287L16.3734 0.0737305H12.3227L12.0187 6.15287C11.9761 7.00694 11.646 7.83484 11.0895 8.48406C10.2834 9.42463 9.83936 10.6249 9.83936 11.8637V22.3985H18.8568V11.8637C18.8568 10.6249 18.4128 9.42468 17.6065 8.48406ZM15.1242 1.38696L15.1986 2.87528H13.4974L13.5718 1.38696H15.1242ZM12.0866 9.33871C12.8314 8.4697 13.2731 7.36156 13.3303 6.21844L13.4318 4.1885H15.2643L15.3658 6.21848C15.423 7.3616 15.8647 8.46974 16.6095 9.33875C17.2177 10.0483 17.5436 10.9084 17.5436 11.9803H11.1526C11.1525 10.9082 11.4785 10.0482 12.0866 9.33871ZM17.5436 13.2935V17.5834H11.1525V13.2935H17.5436ZM11.1525 21.0853V18.8966H17.5436V21.0853H11.1525Z"
        fill={fill}
      />
      <path d="M12.5972 14.7817H16.0991V16.095H12.5972V14.7817Z" fill="white" />
      <path
        d="M6.42641 10.5796H1.25835L0.363427 13.4923C-0.633354 15.8799 0.710556 18.5465 2.93082 18.5465H3.18577V21.0854H1.39103V22.3986H6.29373V21.0854H4.49899V18.5465H4.75393C6.98663 18.5465 8.3182 15.8801 7.32128 13.4923L6.42641 10.5796ZM2.22869 11.8928H5.45607C6.20911 14.3438 6.04444 13.8236 6.14262 14.0815H1.54213C1.6461 13.8085 1.46807 14.3685 2.22869 11.8928ZM4.75393 17.2333H2.93082C2.20746 17.2333 1.44802 16.5755 1.35662 15.3947H6.32814C6.23682 16.5743 5.47756 17.2333 4.75393 17.2333Z"
        fill={fill}
      />
    </svg>
  );
};

DrinksIcon.defaultProps = {
  width: 19,
  height: 23,
  fill: "#A88894",
};

export default DrinksIcon;
